import { Fragment } from 'react';
import { cardSrc, parseJokerCards, parseJoker20Rdesc } from './resultParsers';

export default function Joker20Result({ detail }) {
  const cards = parseJokerCards(detail?.card);
  const rdesc = parseJoker20Rdesc(detail?.rdesc);
  const winValue = detail?.win;
  const winner = detail?.winnat || rdesc.winner || '';
  const isAWinner = winValue === '1' || winner === 'Player A';
  const isBWinner = winValue === '2' || winner === 'Player B';

  return (
    <div className="row row5">
      <div className="col-12 col-lg-7">
        <div className="casino-result-content joker-result">
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              <div className="d-inline-block">
                <h4 className="text-playerb">Joker</h4>
                {cards.joker.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="casino-result-content-diveder d-none-mobile"></div>
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {isAWinner && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Player A</h4>
                {cards.playerA.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="casino-result-content-diveder"></div>
          <div className="casino-result-content-item text-center">
            <div className="casino-result-cards">
              {isBWinner && (
                <div className="casino-result-cards-item">
                  <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                </div>
              )}
              {' '}
              <div className="d-inline-block">
                <h4>Player B</h4>
                {cards.playerB.map((code, i) => (
                  <Fragment key={i}>
                    {' '}
                    <div className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-lg-5">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winner || (isAWinner ? 'Player A' : isBWinner ? 'Player B' : '')}</div>
          </div>
          {rdesc.oddEven && (
            <div className="casino-result-desc-item">
              <div>Odd/Even</div>
              <div>{rdesc.oddEven}</div>
            </div>
          )}
          {rdesc.color && (
            <div className="casino-result-desc-item">
              <div>Color</div>
              <div>{rdesc.color}</div>
            </div>
          )}
          {rdesc.suit && (
            <div className="casino-result-desc-item">
              <div>Suit</div>
              <div>{rdesc.suit}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
